import Header from './components/Header'
import Hero from './components/Hero'
import FileUpload from './components/FileUpload'
import HowToCompress from './components/HowToCompress'
import CodeSamples from './components/CodeSamples'
import FAQ from './components/FAQ'
import Features from './components/Features'
import Footer from './components/Footer'
import RelatedGuides from '../../components/RelatedGuides'
import { useSEO, SITE_URL } from '../../hooks/useSEO'
import {
  DEFAULT_LOCALE,
  LocaleProvider,
  getHomeStrings,
  localeHomePath,
  localeOgImage,
  locales,
} from '../../i18n'

// Every language version lists all versions, plus x-default for everyone else
const alternates = [
  ...locales.map((locale) => ({ hreflang: locale.hreflang, href: localeHomePath(locale.code) })),
  { hreflang: 'x-default', href: '/' },
]

function buildStructuredData(strings, path) {
  const url = `${SITE_URL}${path === '/' ? '/' : `${path}/`}`
  return {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'Organization',
        '@id': `${SITE_URL}/#organization`,
        name: 'Compress GLB',
        url: `${SITE_URL}/`,
      },
      {
        '@type': 'WebSite',
        '@id': `${SITE_URL}/#website`,
        name: 'Compress GLB',
        url: `${SITE_URL}/`,
        publisher: { '@id': `${SITE_URL}/#organization` },
      },
      {
        '@type': 'WebApplication',
        name: 'Compress GLB',
        url,
        inLanguage: strings.locale.hreflang,
        description: strings.seo.appDescription,
        applicationCategory: 'MultimediaApplication',
        operatingSystem: 'Web browser',
        publisher: { '@id': `${SITE_URL}/#organization` },
        offers: {
          '@type': 'Offer',
          price: '0',
          priceCurrency: 'USD',
          description: strings.seo.offerDescription,
        },
        featureList: strings.seo.featureList,
      },
      {
        '@type': 'FAQPage',
        inLanguage: strings.locale.hreflang,
        mainEntity: strings.faq.items.map((faq) => ({
          '@type': 'Question',
          name: faq.question,
          acceptedAnswer: { '@type': 'Answer', text: faq.answer },
        })),
      },
    ],
  }
}

export default function Home({ locale = DEFAULT_LOCALE }) {
  const strings = getHomeStrings(locale)
  const path = localeHomePath(locale)

  useSEO({
    title: strings.seo.title,
    description: strings.seo.description,
    canonical: path,
    lang: strings.locale.hreflang,
    alternates,
    ogTitle: strings.seo.ogTitle,
    ogDescription: strings.seo.ogDescription,
    ogImage: localeOgImage(locale),
    structuredData: buildStructuredData(strings, path),
  })

  return (
    <LocaleProvider value={locale}>
      <div className="min-h-screen bg-background text-foreground">
        <Header />
        <main className="max-w-5xl mx-auto px-4 sm:px-8 lg:px-16">
          <div className="space-y-16 sm:space-y-20 lg:space-y-24 py-16">
            <Hero />
            <FileUpload />
            <HowToCompress />
            <Features />
            <CodeSamples />
            <FAQ />
            {locale === DEFAULT_LOCALE && (
              <RelatedGuides
                title="GLB optimization guides"
                slugs={['reduce-glb-file-size', 'what-is-a-glb-file', 'draco-vs-meshopt']}
              />
            )}
          </div>
        </main>
        <Footer />
      </div>
    </LocaleProvider>
  )
}
